module.exports = __webpack_public_path__ + "img/moonsmall_blue.5dbd43b9.svg";